export default __webpack_public_path__ + "3d50a17da03fda0f2a465c975ec3851c.png";